__turbopack_context__.v({
  "back_button": "MobileMenu-module-scss-module__3wVdMG__back_button",
  "genre_submenu": "MobileMenu-module-scss-module__3wVdMG__genre_submenu",
  "genres_button": "MobileMenu-module-scss-module__3wVdMG__genres_button",
  "genres_submenu_open": "MobileMenu-module-scss-module__3wVdMG__genres_submenu_open",
  "genres_toggle": "MobileMenu-module-scss-module__3wVdMG__genres_toggle",
  "is_open": "MobileMenu-module-scss-module__3wVdMG__is_open",
  "links": "MobileMenu-module-scss-module__3wVdMG__links",
  "live_tv_icon": "MobileMenu-module-scss-module__3wVdMG__live_tv_icon",
  "mobile_menu": "MobileMenu-module-scss-module__3wVdMG__mobile_menu",
  "mobile_menu_genre_nav_link": "MobileMenu-module-scss-module__3wVdMG__mobile_menu_genre_nav_link",
  "mobile_menu_inner": "MobileMenu-module-scss-module__3wVdMG__mobile_menu_inner",
  "mobile_menu_user_image_initial": "MobileMenu-module-scss-module__3wVdMG__mobile_menu_user_image_initial",
  "mobile_menu_wrapper": "MobileMenu-module-scss-module__3wVdMG__mobile_menu_wrapper",
  "my_station_icon": "MobileMenu-module-scss-module__3wVdMG__my_station_icon",
  "passport_compass": "MobileMenu-module-scss-module__3wVdMG__passport_compass",
  "personal": "MobileMenu-module-scss-module__3wVdMG__personal",
  "user_settings_submenu": "MobileMenu-module-scss-module__3wVdMG__user_settings_submenu",
  "user_settings_submenu_button_title": "MobileMenu-module-scss-module__3wVdMG__user_settings_submenu_button_title",
  "user_settings_submenu_open": "MobileMenu-module-scss-module__3wVdMG__user_settings_submenu_open",
  "user_settings_toggle_button": "MobileMenu-module-scss-module__3wVdMG__user_settings_toggle_button",
});
